import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/subscriptions/actions.ts
import { Exception } from "@wbk/logger";
var getSubscriptionAction = (_0) => __async(void 0, [_0], function* ({ actions, slug, selected_timeslot, lang }) {
  try {
    const url = `/subscriptions/userbenefits?lang=${lang}`;
    const data = yield fetchClient({
      url,
      options: {
        method: "POST",
        body: JSON.stringify({ event_slug: slug, actions, selected_timeslot, lang })
      }
    });
    if (!data.data || Array.isArray(data.data)) {
      return null;
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getSubscriptionActionException",
      context: { tags: { journey: "subscribe" }, extra: { actions, slug, selected_timeslot } }
    });
  }
});

export {
  getSubscriptionAction
};
//# sourceMappingURL=chunk-BYK6XBGD.mjs.map